import { useState, useRef } from "react";

const useStateRef = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const ref = useRef(value);
  ref.current = value;

  return [value, setValue, ref];
};

export { useStateRef };
